<template>
  <div class="sms-plan-page">
    <div class="top-bar">
      <div class="logo">
        <img
          src="/other/other/smsplan/imgs/logo.png"
          alt="四川手机报"
          class="top-bar__logo-img"
        />
      </div>
      <div class="title">精彩业务推荐</div>
    </div>

    <div class="container">
      <div class="goods-box">
        <div class="group list active">
          <div class="item">
            <div class="l">
              <img src="/other/other/smsplan/imgs/tk.png" alt="" />
            </div>
            <div class="r">
              <p class="title">四川手机报&nbsp; (每月5元)</p>
              <span class="tag">
                本报是一份及时、准确、权威的新闻手机报，每天会向读者提供重要的时政要闻、财经新闻、民生资讯以及便民信息，同时也会为读者提供生活娱乐的信息，引导休闲健康生活。
              </span>
              <div class="buy">
                <div class="price"></div>
                <div class="btn">
                  <a
                    href="sms:10658678"
                    n="sc"
                    rel="四川移动用户编辑短信sc发送到10658678"
                    @click="handleSmsClick"
                  >
                    订购
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="item">
            <div class="l">
              <img src="/other/other/smsplan/imgs/tk.png" alt="" />
            </div>
            <div class="r">
              <p class="title">四川手机报-四川快讯版&nbsp; (每月2元)</p>
              <span class="tag">
                本报是一款集短信、彩信、短视频为一体的多媒体手机报，定期向读者提供最新、最快的精选新闻资讯、视讯。读者无需下载APP，便可在短信界面直接点击播放观看。
              </span>
              <div class="buy">
                <div class="price"></div>
                <div class="btn">
                  <a
                    href="sms:10086"
                    n="ktsckx"
                    rel="四川移动用户编辑短信ktsckx发送到10086"
                    @click="handleSmsClick"
                  >
                    订购
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="item">
            <div class="l">
              <img src="/other/other/smsplan/imgs/tk.png" alt="" />
            </div>
            <div class="r">
              <p class="title">四川特快&nbsp; (每月1.6元)</p>
              <span class="tag">
                “四川特快”主要为读者报道四川本地重要新闻、国际国内热点事件，以及财经、体育、娱乐等重要新闻内容。
              </span>
              <div class="buy">
                <div class="price"></div>
                <div class="btn">
                  <a
                    href="sms:10621111"
                    n="6"
                    rel="发送6到10621111"
                    @click="handleSmsClick"
                  >
                    订购
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="item">
            <div class="l">
              <img src="/other/other/smsplan/imgs/tk.png" alt="" />
            </div>
            <div class="r">
              <p class="title">娱乐花边&nbsp; (每月6元)</p>
              <span class="tag">
                为读者提供全球最新的热点娱乐体育综合信息，包括文学、艺术、明星、演出、各类体育比赛资讯等。
              </span>
              <div class="buy">
                <div class="price"></div>
                <div class="btn">
                  <a
                    href="sms:10621111"
                    n="YLHB"
                    rel="发送YLHB到10621111"
                    @click="handleSmsClick"
                  >
                    订购
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const FLEXIBLE_SCRIPT_ID = "sms-plan-flexible-js";
const FLEXIBLE_SCRIPT_SRC = "/main/main/js/flexible.js";

let flexibleScriptPromise = null;

/**
 * 动态加载 rem 自适应脚本。
 * @returns {Promise<void>}
 */
function loadFlexibleScript() {
  if (window.flexibleInit) {
    return Promise.resolve();
  }

  if (!flexibleScriptPromise) {
    flexibleScriptPromise = new Promise(function (resolve, reject) {
      var existing = document.getElementById(FLEXIBLE_SCRIPT_ID);

      if (existing) {
        existing.addEventListener(
          "load",
          function () {
            resolve();
          },
          { once: true },
        );
        existing.addEventListener(
          "error",
          function () {
            reject(new Error("flexible.js 加载失败"));
          },
          { once: true },
        );
        return;
      }

      var script = document.createElement("script");
      script.id = FLEXIBLE_SCRIPT_ID;
      script.src = FLEXIBLE_SCRIPT_SRC;
      script.async = true;
      script.onload = function () {
        resolve();
      };
      script.onerror = function () {
        reject(new Error("flexible.js 加载失败"));
      };
      document.head.appendChild(script);
    });
  }

  return flexibleScriptPromise;
}

export default {
  name: "SmsPlan",
  mounted() {
    loadFlexibleScript()
      .then(function () {
        if (typeof window.flexibleInit === "function") {
          window.flexibleInit();
        }
      })
      .catch(function (error) {
        console.error("初始化 rem 自适应失败:", error);
      });
  },
  beforeDestroy() {
    if (typeof window.flexibleDestroy === "function") {
      window.flexibleDestroy();
    }
  },
  methods: {
    handleSmsClick(event) {
      var el = event.currentTarget;
      var rel = el.getAttribute("rel") || "";
      if (!window.confirm(rel)) {
        event.preventDefault();
        return;
      }

      var href = el.getAttribute("href") || "";
      var n = el.getAttribute("n") || "";
      if (/android/i.test(navigator.userAgent) && n) {
        el.setAttribute("href", href + "?body=" + n);
      }
    },
  },
};
</script>

<style scoped>
.sms-plan-page,
.sms-plan-page * {
  margin: 0;
  padding: 0;
  border: 0;
  list-style: none;
  text-decoration: none;
  box-sizing: border-box;
  font-family: "微软雅黑", "Microsoft YaHei", sans-serif;
  -webkit-tap-highlight-color: transparent;
}

.sms-plan-page {
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  text-align: left;
  background-image: linear-gradient(#ceeeff, #f3f3f3);
  background-size: 100% 3.35rem;
  background-repeat: no-repeat;
  background-color: #f3f3f3;
  color: #333;
}

.sms-plan-page img {
  vertical-align: middle;
  max-width: 100%;
}

.sms-plan-page .top-bar {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 1.4rem;
  padding: 0 0.3rem;
}

.sms-plan-page .top-bar .logo {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
  z-index: 2;
}

.sms-plan-page .top-bar__logo-img {
  height: 0.8rem;
}

.sms-plan-page .top-bar .title {
  position: absolute;
  left: 0;
  top: 1.4rem;
  width: 100%;
  height: 0.4rem;
  text-align: center;
  font-size: 0.32rem;
  font-weight: 700;
  color: #244895;
  z-index: 2;
}

.sms-plan-page .container {
  width: 100%;
  padding: 0.6rem 0.3rem 0.5rem;
}

.sms-plan-page .goods-box {
  width: 100%;
  margin-top: 0.25rem;
  margin-bottom: 0.15rem;
  background: #fff;
  border-radius: 0.25rem;
  padding-top: 0.3rem;
  overflow: hidden;
}

.sms-plan-page .group.list .item {
  display: flex;
  align-items: flex-start;
  width: 100%;
  padding: 0.35rem;
  background: #fff;
  border-bottom: 0.01rem solid #f3f3f3;
}

.sms-plan-page .group.list .item:last-child {
  border-bottom: 0;
}

.sms-plan-page .group.list .item .l {
  flex-shrink: 0;
  width: 2.24rem;
  height: 2.24rem;
  margin-right: 0.3rem;
  overflow: hidden;
  background: #fafafa;
  border-radius: 0.08rem;
}

.sms-plan-page .group.list .item .l img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sms-plan-page .group.list .item .r {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.sms-plan-page .group.list .item .r .title {
  display: block;
  font-size: 0.26rem;
  font-weight: 700;
  line-height: 1.4;
  color: #000;
}

.sms-plan-page .group.list .item .r span.tag {
  display: block;
  width: 100%;
  margin-top: 0.12rem;
  padding: 0.1rem 0.12rem;
  font-size: 0.22rem;
  line-height: 1.5;
  color: #999;
  background: #f5f5f5;
  word-break: break-word;
  white-space: normal;
}

.sms-plan-page .group.list .item .r .buy {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  width: 100%;
  margin-top: 0.2rem;
}

.sms-plan-page .group.list .item .r .buy .btn a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 0.6rem;
  border-radius: 0.6rem;
  background-image: linear-gradient(to right, #fe5b00, #ff2b00);
  font-size: 0.24rem;
  color: #fff;
}

.sms-plan-page .group.list {
  display: none;
}

.sms-plan-page .group.list.active {
  display: block;
}
</style>
